// extracted by mini-css-extract-plugin
export default {"fields":"N8Prlp","gaps":"obzzSC","time":"A_Hpbr","mobile":"vVSDVF"};